<template lang="pug">
section.v-collections.collections.main-page-section
	v-loader(:loading="loading")
	template(v-if="collections")
			.collections__content
				.collections__head(v-if="collections.title")
					component.collections__head-title(:is="collections.titleLevel ? collections.titleLevel : 'h1'" :class="collections.titleStyleLevel") {{collections.title}}
				.collections__sort
					.filter-short
						.filter-short__sort-left
							v-field(:field="{type: 'toggler', options: collections.tags.options}"
								v-model="state.tags"
								@update:model-value="sortChanged")
						.filter-short__sort-right
							a.filter-short--sort-link(:href="collections.navigationLink.link" :class="[{'disabled': collections.navigationLink.disabled}]")
								span {{collections.navigationLink.text}}
								v-svg-icon.filter-short--sort-link-icon(icon="arrow-link")

							.filter-short__sort-sort(v-if="!isXs && collections.sort")

							.filter-short__sort-view(v-if="!isXs")
								v-field(:field="{type: 'view-picker', options: collections.view?.options}"
									@update:model-value="viewChanged"
									v-model="state.view")
							.filter-short__sort-action(v-if="collections.filterButton")
								button.btn.btn--white.btn--md(@click="showFilter" v-if="!isXs")
									template(v-if="changedFilters && changedFilters.length")
										.btn__round {{changedFilters.length}}
									template(v-else)
										v-svg-icon.filter-icon(icon="filter")
									| {{collections.filterButton.text || 'Фильтр'}}
								a.filter-short--sort-link(:href="collections.navigationLink.link" :class="[{'disabled': collections.navigationLink.disabled}]")
									span {{collections.navigationLink.text}}
									v-svg-icon.filter-short--sort-link-icon(icon="arrow-link")
								button.btn.btn--blur.btn--fw(@click="showFilter" v-if="isXs")
									.btn__content
										template(v-if="changedFilters && changedFilters.length")
											.btn__round.white {{changedFilters.length}}
										template(v-else)
											v-svg-icon.filter-icon(icon="filter")
										| {{collections.filterButton.text || 'Фильтр'}}
				transition-group(tag="div" class="collections__grid"
					@before-enter="onBeforeEnter"
					@enter="onEnter"
					@leave="onLeave"
					appear
					)
					template(v-for="(item, index) in collections.items" :key="item" )
						.collections__grid-item(:data-index="index")
							v-collection-card(:data-source="item")
				.collections__pagination(v-if="state.page")
					v-page-nav(:page="state.page" :pagination-button="collections.paginationButton" @navigate="navigate")
			.collections__filter
				transition(name="show-aside")
					.filter-aside(v-if="asideOpen")
						.filter-aside__overlay(@click.stop="closeFilter")
						.filter-aside__inner.scrollbar
							.filter-aside__head
								.filter-aside__title(v-html="collections?.filtersTitle" )
								button.filter-aside__close(@click.stop="closeFilter")
									v-svg-icon.filter-aiside__close-icon(icon="cross")
							.filter-aside__body(v-if="collections.filters && collections.filters.length")
								v-filter(ref="filter"
									:filters="collections.filters"
									:filterActions="collections.filterActions"
									@close-filter="closeFilter"
									@filter-changed="filterChanged"
									@filter-updated="filterUpdated"
									@request-reset="resetFilter"
									@request-reset-all="resetAllFilters")
									template(#sort="" v-if="collections.sort")
										v-field(:field="{type: 'radio-list', options: collections.sort?.options, size: 'md'}"
											@update:model-value="sortChanged"
											v-model="state.sort")
								//-template(v-for="(field, index) in collections.filters" :key="index" )
									//.filter-aside__row
									//	v-field(:field="field")
</template>

<script>
	import controller from '../scripts/controller/controller.js';
	import sourceMixin from '../components/mixins/v-mixin-source.vue';
	import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
	import scrollLock from 'scroll-lock';
	import gsap from 'gsap';

	export default {
		mixins: [
			sourceMixin,
			isMobMixin
		],
		data() {
			return {
				collections: null,
				state: {
					page: null,
					sort: null,
					tags: null,
					view: null,
					filter: null
				},
				isNavigate: false,
				changedFilters: null,
				asideOpen: false
			};
		},

		methods: {
			onBeforeEnter(el) {
				el.style.opacity = 0;
				el.style.scale = 0.4;
			},

			onEnter(el, done) {
				gsap.to(el, {
					opacity: 1,
					scale: 1,
					duration: 0.5,
					delay: 0.2,
					ease: 'power2.out',
					onComplete: done
				})
			},

			onLeave(el, done) {
				gsap.to(el, {
					opacity: 0.4,
					delay: 0.2,
					onComplete: done
				})
			},

			dataSet(data, options = {}) {
				if (options.append && this.collections && this.collections.items) {
					let oldItems = this.collections.items;
					this.collections = data;
					this.collections.items = oldItems.concat(this.collections.items);
				} else {
					if (!this.remoteSet && !this.collections && data.remoteSet) {
						this.remoteSet  = data.remoteSet;
					}
					this.collections = data;
				}
				if (this.remoteSet && this.collections.remoteSet && this.remoteSet !== this.collections.remoteSet) {
					history.pushState(this.collections.remoteSet, this.collections.seo.title, this.collections.remoteSet);
					this.remoteSet = this.collections.remoteSet;
					if (this.collections.seo) {
						if (document.title !== this.collections.seo.title) {
							document.title = this.collections.seo.title;
						}
						if (!document.querySelector('meta[name="description"]')) {
							let meta = document.createElement('meta');
							meta.name = 'description';
							document.getElementsByTagName('head')[0].appendChild(meta);
						}
						if (!document.querySelector('meta[name="keywords"]')) {
							let meta = document.createElement('meta');
							meta.name = 'keywords';
							document.getElementsByTagName('head')[0].appendChild(meta);
						}
						if (this.collections.seo.robots && document.querySelector('meta[name="robots"]')) {
							document.querySelector('meta[name="robots"]').setAttribute('content', this.collections.seo.robots);
						} else if (this.collections.seo.robots && !document.querySelector('meta[name="robots"]')) {
							let meta = document.createElement('meta');
							meta.name = 'robots';
							document.getElementsByTagName('head')[0].appendChild(meta);
							document.querySelector('meta[name="robots"]').setAttribute('content', this.collections.seo.robots);
						} else if (!this.collections.seo.robots && document.querySelector('meta[name="robots"]')) {
							document.querySelector('meta[name="robots"]').remove();
						}
						if (this.collections.seo.canonical && document.querySelector('link[rel="canonical"]')) {
							document.querySelector('link[rel="canonical"]').setAttribute('href', this.collections.seo.canonical);
						} else if (this.collections.seo.canonical && !document.querySelector('link[rel="canonical"]')) {
							let meta = document.createElement('link');
							meta.rel = 'canonical';
							meta.href = this.collections.seo.canonical;
							document.getElementsByTagName('head')[0].appendChild(meta);
						} else if (!this.collections.seo.canonical && document.querySelector('link[rel="canonical"]')) {
							document.querySelector('link[rel="canonical"]').remove();
						}
						document.querySelector('meta[name="description"]').setAttribute('content', this.collections.seo.description);
						document.querySelector('meta[name="keywords"]').setAttribute('content', this.collections.seo.keywords);
						if (document.querySelector('#bx-panel')) {
							document.querySelector('#bx-panel').remove();
						}
					}
				}
				this.state.sort = this.collections.sort ? this.collections.sort.value : null;
				if (this.isNavigate) {
					window.scrollTo({top: 0, behavior: 'smooth'});
					this.isNavigate = false
				}
				this.state.page = this.collections.page;
				this.state.tags = this.collections.tags ? this.collections.tags.value : null;
				this.state.view = this.state.view || this.collections.view && this.collections.view.value || 'grid';
			},
			showFilter() {
				this.asideOpen = true;
				scrollLock.enablePageScroll();
				scrollLock.disablePageScroll(document.querySelectorAll('.filter-aside__inner'));
			},
			closeFilter() {
				this.asideOpen = false;
				scrollLock.enablePageScroll(document.querySelectorAll('.filter-aside__inner'));
			},
			navigate(page) {
				this.isNavigate = true;
				this.state.page.offset = page.offset;
				this.state.page.limit = page.limit;
				this.requestDataLoad({append: page.append});
			},

			debounce(ms = 500, fn) {
				clearTimeout(this.debounceFilterId);
				this.debounceFilterId = setTimeout(() => {
					fn();
				}, 500)
			},

			sortChanged() {
				this.debounce(500, () => {
					this.state.page.offset = 0;
					this.requestDataLoad();
				})
			},

			viewChanged() {
				this.debounce(500, () => {
					this.requestDataLoad();
				})
			},

			filterUpdated(filterValue, changedFilters) {
				this.state.filter = filterValue;
				this.changedFilters = changedFilters;
				// update url except markup pages
				if (window.location.pathname.indexOf('/local/') < 0) {
					window.history.replaceState(null, null, this.collections.remote);
				}
			},

			filterChanged(filterValue) {
				this.state.filter = filterValue;
				this.requestDataLoad();
			},

			requestDataLoad(dataSetOptions) {
				this.dataLoad({
					url: this.collections.remote,
					delay: true,
					data: {
						page: this.state.page,
						sort: this.state.sort,
						tags: this.state.tags,
						view: this.state.view,
						filter: this.state.filter
					}
				}, dataSetOptions);
			},


			resetFilter(e) {
				this.$refs.filter.resetFilter(e);
			},

			resetAllFilters(e) {
				this.$refs.filter.resetAll(e);
			}
		}
	};
</script>